import React from 'react';
import TextConstants from "src/common/helpers/TextConstants";

const Dashboard = React.lazy(() => import('./views/data/dashboard'));
const DataView = React.lazy(() => import('./views/data/data-view'));
const LastData = React.lazy(() => import('./views/data/last-data'));
const UnitSettings = React.lazy(() => import('./views/settings/unit-settings'));
const ChannelSettings = React.lazy(() =>
  import('./views/settings/channel-settings')
);
// const UsersManagement = React.lazy(() => import('./views/users-management'));
const UsersManagement = React.lazy(() =>
  import('./views/users-management/new-flow')
);

const routes = [
  { path: '/', exact: true, name: TextConstants.Common.Home },
  { path: '/dashboard', name: TextConstants.Dashboard.Title, component: Dashboard },
  { path: '/data-view', name: TextConstants.DataView.Title, component: DataView },
  { path: '/last-data', name: TextConstants.LastData.Title, component: LastData },
  { path: '/unit-settings', name: TextConstants.DeviceSettings.Title, component: UnitSettings },
  {
    path: '/channel-settings',
    name: TextConstants.ChannelSettings.Title,
    component: ChannelSettings,
  },
  {
    path: '/users-management',
    name: TextConstants.UsersManagement.Title,
    component: UsersManagement,
  },
];

export default routes;
